








import {Component, Vue} from 'vue-property-decorator'
import InvoiceDocument from '@/components/InvoiceDocument.vue'
import {namespace} from 'vuex-class'

const issue = namespace('issue')

@Component({
  components: {InvoiceDocument},
})
export default class InvoiceDocumentPage extends Vue {
  @issue.State('previewData') previewData: string
  @issue.Mutation('clear') clear: () => void

  get documentData(): string {
    return this.previewData || ''
  }

  destroyed() {
    this.clear()
  }
}
